import React from 'react';
import styles from '../config/styles';
import { withStyles, Typography, Button,Snackbar } from '../../node_modules/@material-ui/core';
import {auth,firestore} from '../config/firebase';
import MuiAlert from '@material-ui/lab/Alert';


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

class Subscribe extends React.Component{
    constructor(props){
        super(props);
        this.state ={
          user: false,
          newEmail: '',
          snackbar:false,
          message:'',
          type:''
        }
    }

    componentWillMount() {
        const result = auth().currentUser;
            if (result){
                console.log(result);
                this.setState({user: result});
            };
    }
        
    handleEmailChange = (event) => {
        this.setState({newEmail: event.target.value});
    }
  
    generatePassword = () => {
        var length = 10;
        var password = '', character; 
        while (length > password.length) {
            if (password.indexOf(character = String.fromCharCode(Math.floor(Math.random() * 94) + 33), Math.floor(password.length / 94) * 94) < 0) {
            password += character;
            }
        }
        return password;
    }


    subscribe = async(event)=>{
        event.preventDefault()
        try {
            if(this.state.newEmail.split('@')[1]){
               
                await firestore.collection('subscribers').add({email:this.state.newEmail})
                this.setState({snackbar:true,message:'subscribed successfully',type:'success'})
            }
            else{
                this.setState({snackbar:true,message:'Enter Valid Email',type:'error'})
                
            }
           
            
            
        } catch (error) {
            this.setState({snackbar:true,message:error.message,type:'error'})
           
            
        }

    }

    handleClose = ()=>{
        this.setState({snackbar:false,message:'',type:''})
    }
  
    logout = () => {
        auth().signOut()
        this.setState({user: null});
    }
    
    render(){
        const {classes} = this.props;
        return(
            <>
            <section className={[classes.section, classes.subscribe].join(" ")}>
                {
                    this.state.user ?                     
                    (
                        <Typography variant="headline" className={[classes.centered,classes.innerBox].join(" ")}>
                            Thank you have succesfully subscribed to our newsletter, we will update you on our progress.
                        </Typography>
                    ) : (
                        <div className={classes.centered}>
                            <Typography variant="h4">
                            Join our newsletter & <br/>
                            be upto date with our progress.
                            </Typography>
                            <form style={{"paddingTop":"3em"}} onSubmit={this.subscribe}>
                                <div className={classes.subscribeInput}>
                                    <div style={{flex:2}}>

                                <input placeholder="Email Address" onChange={this.handleEmailChange} className={classes.newsletterInput}/>
                                    </div>
                                        
                                <Button type="submit" variant="contained" color="primary" className={classes.newsletterButton} >Join Now</Button>
                                  

                                </div>
                            </form>
                        </div>
                    )                    
                }                                
            </section>
            <Snackbar
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
                }}
                open={this.state.snackbar}
                autoHideDuration={4000}
                onClose={this.handleClose}
            
            >
                <Alert onClose={this.handleClose} severity={this.state.type}>
                {this.state.message}
                </Alert>
            </Snackbar>
            </>
        )
    }
}

export default withStyles(styles)(Subscribe);